/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DomeggookSkuVo
 */
export interface DomeggookSkuVo {
    /**
     * 
     * @type {string}
     * @memberof DomeggookSkuVo
     */
    proNm?: string;
    /**
     * 
     * @type {string}
     * @memberof DomeggookSkuVo
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DomeggookSkuVo
     */
    proCost?: string;
    /**
     * 
     * @type {number}
     * @memberof DomeggookSkuVo
     */
    proQty?: number;
    /**
     * 
     * @type {string}
     * @memberof DomeggookSkuVo
     */
    imgUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DomeggookSkuVo
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof DomeggookSkuVo
     */
    skuId?: string;
}

/**
 * Check if a given object implements the DomeggookSkuVo interface.
 */
export function instanceOfDomeggookSkuVo(value: object): value is DomeggookSkuVo {
    return true;
}

export function DomeggookSkuVoFromJSON(json: any): DomeggookSkuVo {
    return DomeggookSkuVoFromJSONTyped(json, false);
}

export function DomeggookSkuVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomeggookSkuVo {
    if (json == null) {
        return json;
    }
    return {
        
        'proNm': json['proNm'] == null ? undefined : json['proNm'],
        'color': json['color'] == null ? undefined : json['color'],
        'proCost': json['proCost'] == null ? undefined : json['proCost'],
        'proQty': json['proQty'] == null ? undefined : json['proQty'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'size': json['size'] == null ? undefined : json['size'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
    };
}

export function DomeggookSkuVoToJSON(json: any): DomeggookSkuVo {
    return DomeggookSkuVoToJSONTyped(json, false);
}

export function DomeggookSkuVoToJSONTyped(value?: DomeggookSkuVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proNm': value['proNm'],
        'color': value['color'],
        'proCost': value['proCost'],
        'proQty': value['proQty'],
        'imgUrl': value['imgUrl'],
        'size': value['size'],
        'skuId': value['skuId'],
    };
}

